export const ReturnsFiltersEnum = {
  Status: 'Status',
  Search: 'Search',
  FulfillmentCenter: 'FulfillmentCenter',
  Product: 'Product',
  ReferenceId: 'ReferenceId',
  ReturnId: 'ReturnId',
  OrderId: 'OrderId',
  TrackingNumber: 'TrackingNumber',
  LabelUrl: 'LabelUrl'
}

export const ReturnsFiltersMessagesMap = {
  All: 'returnsFilters.All',
  Awaiting: 'returnsFilters.Awaiting',
  Arrived: 'returnsFilters.Arrived',
  Processing: 'returnsFilters.Processing',
  Cancelled: 'returnsFilters.Cancelled',
  Completed: 'returnsFilters.Completed',
  Search: 'returnsFilters.Search',
  FulfillmentCenter: 'returnsFilters.FulfillmentCenter',
  Product: 'returnsFilters.Product',
  ReferenceId: 'returnsFilters.ReferenceId',
  ReturnId: 'returnsFilters.ReturnId',
  OrderId: 'returnsFilters.OrderId',
  TrackingNumber: 'returnsFilters.TrackingNumber',
  LabelUrl: 'returnFilters.LabelUrl'
}

export const ReturnsStatuses = {
  AwaitingArrival: 'AwaitingArrival',
  Arrived: 'Arrived',
  Processing: 'Processing',
  Cancelled: 'Cancelled',
  Completed: 'Completed'
}

export const ReturnsStatusesEnum = {
  AwaitingArrival: 'returnsStatuses.AwaitingArrival',
  Arrived: 'returnsStatuses.Arrived',
  Processing: 'returnsStatuses.Processing',
  Cancelled: 'returnsStatuses.Cancelled',
  Completed: 'returnsStatuses.Completed'
}

export const ReturnsStatusTooltipEnum = {
  AwaitingArrival: 'returnsStatusTooltip.AwaitingArrival',
  Arrived: 'returnsStatusTooltip.Arrived',
  Processing: 'returnsStatusTooltip.Processing',
  Cancelled: 'returnsStatusTooltip.Cancelled',
  Completed: 'returnsStatusTooltip.Completed'
}

export const ReturnsViews = {
  AllView: 'all',
  AwaitingView: 'awaiting',
  ArrivedView: 'arrived',
  ProcessingView: 'processing',
  CompletedView: 'completed',
  CancelledView: 'cancelled'
}

export const TransactionsEnum = {
  ReturnLabelInvoice: 'ReturnLabelInvoice',
  ReturnProcessingFee: 'ReturnProcessingFee',
  ReturnToSenderFee: 'ReturnToSenderFee'
}

export const ReturnsTypeEnum = {
  Regular: 'Regular',
  ReturnToSender: 'ReturnToSender'
}
